import axios from "axios";
import { IP_ADDRESS } from "../../config";

const apiClient = axios.create({
  baseURL: `${IP_ADDRESS}/billing`,
});

export default apiClient;
